import React, { Fragment, PureComponent } from 'react';

import SORT_TYPES from 'constants/sortTypes';

import ActionBar from 'components/ActionBar';
import Button from 'components/Button';
import Select from 'components/Select';

class ActionBarContainer extends PureComponent {
  render() {
    return (
      <ActionBar>
        {({ settings, onOrder, onSettingsChange }) => (
          <Fragment>
            <Select
              label="Sorting Type"
              onChange={({ target }) => {
                onSettingsChange({
                  ...settings,
                  sort: target.value,
                });
              }}
              options={SORT_TYPES}
              value={settings.sort}
            />
            {settings.sort === 'paydownOrder' && (
              <div className="hidden--mobile" style={{ display: 'flex', flexFlow: 'column nowrap', width: 150, marginLeft: 15 }}>
                <Button dark style={{ flex: '1 1 auto' }} onClick={onOrder}>
                  Reorder Debts
                </Button>
              </div>
            )}
          </Fragment>
        )}
      </ActionBar>
    );
  }
}

export default ActionBarContainer;



// WEBPACK FOOTER //
// ./src/components/DebtEditor/DebtActions.js